import React, { Component } from 'react';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter,
    TabContent, TabPane, Nav, NavItem, NavLink, Progress,
    Popover, PopoverTitle, PopoverContent,
    Breadcrumb, BreadcrumbItem, Collapse
} from 'reactstrap';
import EditComponents from './editComponents.js';
import UploadImages from './uploadImages'
import Firebase from 'firebase';
import { withRouter } from "react-router-dom";
import Sortable from 'react-sortablejs';
import Validator from './validator'
import Functions from '../functions/container'
import SetDatasets from './setDatasets'
import classnames from 'classnames';
import AddOutPut from './addOutPut'
import OutPut from './outPut'
import DetailFunction from './detailFunction'
import OverWriteDatasets from './overWriteDatasets'
import Select from 'react-select';
import ListIcons from './listIcons'
import {
    BlockPicker, ChromePicker, CirclePicker, CompactPicker,
    SketchPicker, SwatchesPicker, TwitterPicker
} from 'react-color';
import ColorPicker from './colorPicker'


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

const gps_options = [
    { label: "Si", value: "1" },
    { label: "No", value: "0" },
    { label: "Si, solo si esta disponible", value: "2" }
]

export default class editForm extends React.Component {
    constructor() {
        super();
        this.state = {
            tabParams: "basics",
            tabPublish: "publish",
            tabSettings: "global",
            showModalFunctions: false,
            element: {},
            backUp: {},
            onEdit: false,
            data: {},
            elements: {},
            value: "",
            showModal: false,
            draggable: false,
            onMouseOver: "none",
            count: 1,
            activeTab: "1",
            list_elements: true,
            visibility: false,
            page: 0,
            tab: "edit",
            elementos: [
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="calendar" onDoubleClick={() => this.insertElement("calendar", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/calendar.svg" style={{ width: "40%" }} /><br />Calendario</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="camera" onDoubleClick={() => this.insertElement("camera", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/camera.svg" style={{ width: "40%" }} /><br />Cámara</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="barcode" onDoubleClick={() => this.insertElement("barcode", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/barcode.svg" style={{ width: "40%" }} /><br />Código de Barras</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="radiobutton" onDoubleClick={() => this.insertElement("radiobutton", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/radio-button.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Grupo de Opciones</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="buttonGroup" onDoubleClick={() => this.insertElement("buttonGroup", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/button-group.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Grupo de Botones</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="image" onDoubleClick={() => this.insertElement("image", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/image.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Imagen</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="button" onDoubleClick={() => this.insertElement("button", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/button.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Botón</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="input" onDoubleClick={() => this.insertElement("input", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/input.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Entrada de Texto</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="label" onDoubleClick={() => this.insertElement("label", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/label.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Texto</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="checkbox" onDoubleClick={() => this.insertElement("checkbox", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/checkbox.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Checkbox</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="section" onDoubleClick={() => this.insertElement("section", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/section.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Separador</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="stores" onDoubleClick={() => this.insertElement("stores", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/dropdown.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Listado de Locales</NavLink>
                </div>,
                <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" id="dropdown" onDoubleClick={() => this.insertElement("dropdown", this.state.count)}>
                    <NavLink className="nav-link" activeClassName="active" style={{ color: "#FFF", cursor: "pointer" }}><img src="/icons/dropdown.svg" style={{ width: "40%", cursor: "pointer" }} /><br />Listado</NavLink>
                </div>
            ]
        }
        this.setParams = this.setParams.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.setBackUp = this.setBackUp.bind(this);
        this.moveElement = this.moveElement.bind(this);
        this.validadorID = this.validadorID.bind(this);
        this.insertElement = this.insertElement.bind(this);
        this.updateElements = this.updateElements.bind(this);
        this.setFunctions = this.setFunctions.bind(this);
        this.deleteFunctions = this.deleteFunctions.bind(this);
        this.updateDatasets = this.updateDatasets.bind(this);
        this.diccionario = this.diccionario.bind(this);
        this.setOutPut = this.setOutPut.bind(this);
        this.removeOutPut = this.removeOutPut.bind(this);
        this.searchElement = this.searchElement.bind(this);
        this.DateToFormattedString = this.DateToFormattedString.bind(this)
        this.renderForm = this.renderForm.bind(this);
    }

    autoSave() {
        let formId = this.props.match.params.formId;
        var form = this.state.data;
        form.modified_at = new Date();
        if (this.state.data.pages) {
            var formRef = Firebase.database().ref("draft").child(formId).set(form).then();
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    setBackUp() {
        var contex = this;
        var backupRef = Firebase.database().ref('backUp').child(localStorage.client_id).child(this.props.match.params.formId);
        var formRef = Firebase.database().ref('forms')
            .child(this.props.match.params.formId)
            .once('value')
            .then(resp => {
                var data = resp.val();
                if (data) {
                    backupRef.child(resp.val().version).set({
                        data
                    }).then({
                    });
                }
                contex.sendForm();
            });
    }

    componentWillMount() {
        var formRef = Firebase.database().ref("draft")
            .child(this.props.match.params.formId)
            .once('value')
            .then(resp => {
                if (resp.val()) {
                    this.setState({
                        elements: resp.val().pages[0].elements,
                        data: resp.val(),
                        published: resp.val().published,
                        count: Object.values(resp.val().pages)[0].elements.length
                    })
                }
            });
    }

    sendForm() {
        let formId = this.props.match.params.formId;
        var formRef = Firebase.database().ref("forms");
        this.state.data.datasets ?
            formRef.child(formId).set({
                "client_id": localStorage.client_id,
                "version": this.state.data.tag ? 3 : this.state.data.version + 1,
                "name": this.state.data.name,
                "published": this.state.data.published,
                "datasets": this.state.data.datasets,
                "GPS": this.state.data.GPS,
                "modified_at": Firebase.database.ServerValue.TIMESTAMP,
                "output": this.state.data.output ? this.state.data.output : "",
                "pages": this.state.data.pages,
                "icon": this.state.data.icon ? this.state.data.icon : ""
            }).then(resp => {
                var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                var regId = Firebase.database().ref().child('log').push().key;
                logRef.child(regId).set({
                    admin: localStorage.email,
                    timestamp: Firebase.database.ServerValue.TIMESTAMP,
                    action: "publish",
                    target: {
                        type: "form",
                        id: formId,
                        name: this.state.data.name
                    }
                });
                this.refs.container.success(
                    "Formulario actualizado correctamente",
                    this.state.data.name, {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
                this.setState({ showModalSave: false });
                var draftRef = Firebase.database().ref("draft").child(formId).remove();
                this.props.history.push("/formularios");
            }).catch(err => {
                this.refs.container.warning(
                    err,
                    "Error", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    }
                )
            })
            :
            formRef.child(formId).update({
                "client_id": localStorage.client_id,
                "version": this.state.data.tag ? 3 : this.state.data.version + 1,
                "name": this.state.data.name,
                "published": this.state.data.published,
                "GPS": this.state.data.GPS,
                "modified_at": Firebase.database.ServerValue.TIMESTAMP,
                "output": this.state.data.output ? this.state.data.output : "",
                "pages": this.state.data.pages,
                "icon": this.state.data.icon ? this.state.data.icon : ""
            }).then(resp => {
                var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                var regId = Firebase.database().ref().child('log').push().key;
                logRef.child(regId).set({
                    admin: localStorage.email,
                    timestamp: Firebase.database.ServerValue.TIMESTAMP,
                    action: "publish",
                    target: {
                        type: "form",
                        id: formId,
                        name: this.state.data.name
                    }
                });
                this.refs.container.success(
                    "Formulario actualizado correctamente",
                    this.state.data.name, {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
                this.setState({ showModalSave: false });
                var draftRef = Firebase.database().ref("draft").child(formId).remove();
                this.props.history.push("/formularios");
            }).catch(err => {
                this.refs.container.warning(
                    err,
                    "Error", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    }
                )
            })
    }

    updateImage(element) {
        this.setState({ draggable: false });
        this.setState({ element: element });
        this.refs.container.success(
            "Imagen actualizada correctamente",
            "Recargando...", {
                timeOut: 3000,
                extendedTimeOut: 10000
            });
    }

    updateDatasets(newTable) {
        var arrData = this.state.data;
        var arrayEdit = this.state.data.pages[this.state.page].elements;
        if (arrData.datasets) {
            arrData.datasets.push({ id: [newTable][0].dataset, name: [newTable][0].dataset_name });
        } else {
            arrData.datasets = [];
            arrData.datasets.push({ id: [newTable][0].dataset, name: [newTable][0].dataset_name });
        }
        arrayEdit[this.state.index].table = [newTable][0];
        arrData.pages[this.state.page].elements[this.state.index].table = [newTable][0];
        this.setState({ data: arrData, showModalDatasets: false });
    }

    diccionario(name) {
        switch (name) {
            case "show":
                return (
                    "Mostrar"
                )
                break;
            case "filter":
                return (
                    "Filtrar"
                )
                break;
            case "primary":
                return (
                    "Azul"
                )
            case "default":
                return (
                    "Por Defecto"
                )
            case "success":
                return (
                    "Verde"
                )
            case "warning":
                return (
                    "Naranjo"
                )
            case "danger":
                return (
                    "Rojo"
                )
            case "h2":
                return (
                    "Grande"
                )
            case "h4":
                return (
                    "Mediana"
                )
            case "h5":
                return (
                    "Chica"
                )
            case "italic":
                return (
                    "Cursiva"
                )
            case "bold":
                return (
                    "Negrita"
                )
            default:
                break;
        }

    }

    setParams() {
        var arrayEdit = this.state.data.pages[this.state.page].elements;
        switch (this.state.element.element_id) {
            case 'CALENDAR':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Título (opcional):</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.label}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].label = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                            </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'BUTTONGROUP':
                var array = this.state.element.childrens;
                var childrens = {
                    text: "texto",
                    value: "id_btn_grp",
                    style: {
                        backgroundColor: "#FFFFFF",
                        color: "#111111"
                    }
                }
                var flag = false;
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Título (opcional):</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.label}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].label = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Botones:</label>
                                {
                                    this.state.element.childrens.map((button, index) => (
                                        <div key={index} className={"card card-outline-primary mb-3"}>
                                            <div className="card-block-parametros" style={{ padding: "5px" }}>
                                                <blockquote className="card-blockquote">
                                                    <i href="" className="fa fa-times" aria-hidden="true" style={{ marginLeft: "90%" }}
                                                        onClick={() => {
                                                            array.splice(index, 1);
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} >
                                                    </i>
                                                    <label htmlFor="name">Valor:</label>
                                                    <input type="text" className="form-control-parametros" id="name"
                                                        value={button.value} placeholder={button.value}
                                                        onChange={(e) => {
                                                            array[index].value = e.target.value;
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} />
                                                    <label htmlFor="name">Texto:</label>
                                                    <input type="text" className="form-control-parametros" id="name"
                                                        value={button.text} placeholder={button.text}
                                                        onChange={(e) => {
                                                            array[index].text = e.target.value;
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} />
                                                    <br />
                                                    <div className="form-group row">
                                                        <div className="col-md-6">
                                                            <div className="form-group row">
                                                                <label className="col-md-8 form-control-label" >Color de fondo:</label>
                                                                <div className="col-md-3">
                                                                    <ColorPicker
                                                                        index={index}
                                                                        color={button.style.backgroundColor}
                                                                        callBack={(color) => {
                                                                            array[index].style.backgroundColor = color.hex;
                                                                            arrayEdit[this.state.index].childrens = array;
                                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                                        }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group row">
                                                                <label className="col-md-8 form-control-label" >Color del texto:</label>
                                                                <div className="col-md-3">
                                                                    <ColorPicker
                                                                        index={index}
                                                                        color={button.style.color}
                                                                        callBack={(color) => {
                                                                            array[index].style.color = color.hex;
                                                                            arrayEdit[this.state.index].childrens = array;
                                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                                        }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="form-group">
                                <button onClick={() => {
                                    array.push(childrens);
                                    arrayEdit[this.state.index].childrens = array;
                                    this.setState({ elements: arrayEdit, onEdit: true });
                                }} type="button" className="btn btn-outline-success">Añadir nuevo Boton</button>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'BARCODE':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'CAMERA':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'RADIOBUTTON':
                var array = this.state.element.childrens;
                var childrens = {
                    text: "",
                    value: "prueba"
                }
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Título (opcional):</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.label}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].label = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Botones:</label>
                                {
                                    this.state.element.childrens.map((button, index) => (
                                        <div key={index} className={"card card-outline-primary mb-3"}>
                                            <div className="card-block-parametros" style={{ padding: "5px" }}>
                                                <blockquote className="card-blockquote">
                                                    <i href="" className="fa fa-times" aria-hidden="true" style={{ marginLeft: "90%" }}
                                                        onClick={() => {
                                                            array.splice(index, 1);
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} >
                                                    </i>
                                                    <label htmlFor="name">Valor:</label>
                                                    <input type="text" className="form-control-parametros" id="name"
                                                        value={button.value} placeholder={button.value}
                                                        onChange={(e) => {
                                                            array[index].value = e.target.value;
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} />
                                                    <label htmlFor="name">Texto:</label>
                                                    <input type="text" className="form-control-parametros" id="name"
                                                        value={button.text} placeholder={button.text}
                                                        onChange={(e) => {
                                                            array[index].text = e.target.value;
                                                            arrayEdit[this.state.index].childrens = array;
                                                            this.setState({ elements: arrayEdit, onEdit: true });
                                                        }} />
                                                </blockquote>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="form-group">
                                <button onClick={() => {
                                    array.push(childrens);
                                    arrayEdit[this.state.index].childrens = array;
                                    this.setState({ elements: arrayEdit, onEdit: true });
                                }} type="button" className="btn btn-outline-success">Añadir nuevo Boton</button>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'IMAGE':
                var sizes = [
                    {
                        label: "Grande",
                        value: "large"
                    },
                    {
                        label: "Mediana",
                        value: "medium"
                    },
                    {
                        label: "Chica",
                        value: "small"
                    }
                ]
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <Select
                                    name="form-field-name"
                                    className="Select Select--single is-clearable is-searchable has-value"
                                    value={this.state.element.size}
                                    options={sizes}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].size = e.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <UploadImages callBack={this.updateImage} directory={this.state.element.value} element={this.state.element} elements={this.state.data.pages[this.state.page].elements} id={this.props.match.params.formId} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'DROPDOWNLIST':
                const contex = this;
                var arrData = this.state.data;
                var options = [
                    {
                        value: "and",
                        label: "Se deben cumplir todas las condiciones"
                    },
                    {
                        value: "or",
                        label: "Se deben cumplir al menos una condición"
                    }
                ]
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.tabParams === 'basics' })}
                                        onClick={() => { this.setState({ tabParams: "basics" }) }}
                                        style={{ backgroundColor: "#263238", color: "#FFF", borderBottomColor: "#FFF" }}
                                    >
                                        Config. Básica
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.tabParams === 'functions' })}
                                        onClick={() => {
                                            this.setState({ tabParams: "functions" }); if (!this.state.element.function) {
                                                arrData.pages[this.state.page].elements[this.state.index].function = {};
                                                this.setState({ data: arrData })
                                            }
                                        }}
                                        style={{ backgroundColor: "#263238", color: "#FFF", borderBottomColor: "#FFF" }}
                                    >
                                        Config. Filtros
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.tabParams} style={{ backgroundColor: "#263238" }}>
                                <TabPane tabId="basics">
                                    <div className="form-group">
                                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                        <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                            placeholder={this.state.element.id}
                                            onChange={(e) => {
                                                arrayEdit[this.state.index].id = e.target.value;
                                                this.setState({ elements: arrayEdit, onEdit: true });
                                            }} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Título (opcional):</label>
                                        <input type="text" id="username3" name="username3" className="form-control-parametros" value={this.state.element.label}
                                            placeholder="Campo Opcional"
                                            onChange={(e) => {
                                                arrayEdit[this.state.index].label = e.target.value;
                                                this.setState({ elements: arrayEdit, onEdit: true });
                                            }} />
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Visible</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Requerido</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Recordar valor</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    {this.state.element.table.dataset !== "id dataset" ?
                                        <div className="form-group">
                                            <div className="form-control-parametros" ><b>Set de datos: </b>{this.state.element.table.dataset_name}
                                                <span pullRight onClick={(e) => { this.setState({ showModalDatasets: true }) }} style={{ position: "absolute", right: "35px", margin: "auto" }} >
                                                    <i className="fa fa-edit" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <ul>
                                                <li>
                                                    <p><b>Columna valor: </b>{this.state.element.table.col_id}</p>
                                                </li>
                                                <li>
                                                    <p><b>Columna Nombre: </b>{this.state.element.table.col_name}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        :
                                        <div className="form-group">
                                            <button onClick={(e) => { this.setState({ showModalDatasets: true }) }} type="button" className="btn btn-outline-primary">Añadir datos</button>
                                        </div>
                                    }
                                    <Modal isOpen={this.state.showModalDatasets} toggle={() => { this.setState({ showModalDatasets: false }) }} className="modal-dialog modal-lg">
                                        <ModalHeader toggle={() => { this.setState({ showModalDatasets: false }) }}>
                                        </ModalHeader>
                                        <ModalBody>
                                            <SetDatasets element={this.state.element} callBack={this.updateDatasets} />
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={this.state.showModalFunctions} toggle={() => { this.setState({ showModalFunctions: false }) }} className="modal-dialog modal-lg">
                                        <ModalHeader toggle={() => { this.setState({ showModalFunctions: false }) }}>
                                        </ModalHeader>
                                        <ModalBody>
                                            <Functions elements={this.state.data.pages ? this.state.data.pages : []} pages={this.state.data.pages} element={this.state.element} callBack={this.setFunctions} />
                                        </ModalBody>
                                    </Modal>
                                    {
                                        this.state.element.function ?
                                            <div className="form-group">
                                                <div className="form-control-parametros" style={{ height: "40px" }}>
                                                    <div>Funciones: </div>
                                                    <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                                        <button
                                                            onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Añadir Funciones
                                                </button>
                                                    </div>
                                                </div>
                                                <ul>
                                                    {Object.keys(this.state.element.function).map((f, index) => (
                                                        f !== "filter" ?
                                                            <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                            :
                                                            ""
                                                    ))}
                                                </ul>
                                            </div>
                                            :
                                            <div className="form-group">
                                                <div className="form-control-parametros" style={{ height: "40px" }}>
                                                    <div>Funciones: </div>
                                                    <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                                        <button
                                                            onClick={(e) => {
                                                                arrData.pages[this.state.page].elements[this.state.index].function = {};
                                                                this.setState({ data: arrData, showModalFunctions: true })
                                                            }}
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Añadir Funciones
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </TabPane>
                                <TabPane tabId="functions">
                                    {
                                        this.state.element.function ?
                                            Object.values(this.state.element.table)[0] !== "columna id" ?
                                                <div>
                                                    <div className="form-group">
                                                        <div className="form-control-parametros" style={{ height: "40px" }}>
                                                            <div style={{ position: "absolute", top: "60px" }}>Filtros: </div>
                                                            <div style={{ textAlign: "right", position: "relative", top: "-3" }}>
                                                                <button
                                                                    onClick={(e) => {
                                                                        if (this.state.element.function.filter) {
                                                                            arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(this.state.element.function.filter)[0]].col_id_ = { type: "value" };
                                                                        } else {
                                                                            arrData.pages[this.state.page].elements[this.state.index].function.filter = {}
                                                                            arrData.pages[this.state.page].elements[this.state.index].function.filter = {
                                                                                unique: {
                                                                                    col_id_: { type: "value" }
                                                                                }
                                                                            }
                                                                        }
                                                                        this.setState({ data: arrData, onEdit: true });
                                                                    }}
                                                                    type="button"
                                                                    className="btn btn-success btn-circle"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.element.function.filter
                                                            ?
                                                            Object.keys(this.state.element.function).map((fn, indexZ) => (
                                                                fn === "filter" ?
                                                                    Object.values(Object.values(this.state.element.function)[indexZ]).map((d) => (
                                                                        <div>
                                                                            {
                                                                                Object.values(Object.values(Object.values(this.state.element.function)[indexZ])[0]).length > 1 ?
                                                                                    <div className="form-group">
                                                                                        <Select
                                                                                            name="form-field-name"
                                                                                            className="Select Select--single is-clearable is-searchable has-value"
                                                                                            value={Object.keys(Object.values(this.state.element.function)[indexZ])[0]}
                                                                                            options={options}
                                                                                            onChange={(e) => {
                                                                                                var fx = Object.values(this.state.element.function.filter)[0]
                                                                                                arrData.pages[this.state.page].elements[this.state.index].function = { filter: { [e.value]: [fx][0] } }
                                                                                                this.setState({ data: arrData });
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    ""
                                                                            }
                                                                            {
                                                                                Object.values(d).map((f, index) => (
                                                                                    <div key={index} className={"card card-outline-primary mb-3"}>
                                                                                        <div className="card-block-parametros">
                                                                                            <div
                                                                                                style={{ position: "absolute", right: "1%", cursor: "pointer", color: "#d33115" }}
                                                                                                onClick={() => {
                                                                                                    delete arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(Object.values(this.state.element.function)[indexZ])[0]][Object.keys(d)[index]];
                                                                                                    if (Object.values(Object.values(Object.values(this.state.element.function)[indexZ])[0]).length === 1) {
                                                                                                        var fx = Object.values(Object.values(this.state.element.function)[indexZ])[0];
                                                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter = { unique: [fx][0] }
                                                                                                    }
                                                                                                    this.setState({ data: arrData });
                                                                                                }}
                                                                                            >
                                                                                                <i className="fa fa-times" aria-hidden="true"></i>
                                                                                            </div>
                                                                                            <blockquote className="card-blockquote" style={{ paddingRight: "10px", paddingLeft: "10px", paddingTop: "20px" }}>
                                                                                                <DetailFunction
                                                                                                    data={this.state.data.pages}
                                                                                                    col={Object.keys(d)[index]}
                                                                                                    tipo={Object.keys(f)[0]}
                                                                                                    value={Object.values(f)[0]}
                                                                                                    condition={f.condition}
                                                                                                    element={this.state.element}
                                                                                                    updateFilter={(col, type, value, condition) => {
                                                                                                        if (col === Object.keys(d)[index]) {
                                                                                                            arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(Object.values(this.state.element.function)[indexZ])[0]][Object.keys(d)[index]] = { [type]: value, condition: condition };
                                                                                                            this.setState({ data: arrData });
                                                                                                            this.setTrigger(type, this.state.element.id);
                                                                                                        } else {
                                                                                                            delete arrData.pages[this.state.page].elements[this.state.index].function.filter[[Object.keys(Object.values(this.state.element.function)[indexZ])[0]]][Object.keys(d)[index]];
                                                                                                            arrData.pages[this.state.page].elements[this.state.index].function.filter[[Object.keys(Object.values(this.state.element.function)[indexZ])[0]]][col] = { [type]: value };
                                                                                                            this.setState({ data: arrData });
                                                                                                            this.setTrigger(type, this.state.element.id);
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </blockquote>
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    ))
                                                                    :
                                                                    ""
                                                            ))
                                                            :
                                                            ""
                                                    }
                                                </div>
                                                :
                                                ""
                                            :
                                            ""
                                    }
                                </TabPane>
                            </TabContent>
                        </div>
                    </div >
                );
                break;
            case 'STORE':
                var arrData = this.state.data;
                var options = [
                    {
                        value: "and",
                        label: "Se deben cumplir todas las condiciones"
                    },
                    {
                        value: "or",
                        label: "Se deben cumplir al menos una condición"
                    }
                ]
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.tabParams === 'basics' })}
                                        onClick={() => { this.setState({ tabParams: "basics" }) }}
                                        style={{ backgroundColor: "#263238", color: "#FFF", borderBottomColor: "#FFF" }}
                                    >
                                        Config. Básica
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.tabParams === 'functions' })}
                                        onClick={() => { this.setState({ tabParams: "functions" }) }}
                                        style={{ backgroundColor: "#263238", color: "#FFF", borderBottomColor: "#FFF" }}
                                    >
                                        Config. Filtros
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.tabParams} style={{ backgroundColor: "#263238" }}>
                                <TabPane tabId="basics">
                                    <div className="form-group">
                                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                        <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                            placeholder={this.state.element.id}
                                            onChange={(e) => {
                                                arrayEdit[this.state.index].id = e.target.value;
                                                this.setState({ elements: arrayEdit, onEdit: true });
                                            }} />
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Visible</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Requerido</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="clearfix mt-4">
                                            <small><b>Recordar valor</b></small>
                                            <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-control-parametros" style={{ height: "40px" }}>
                                        <div>Funciones: </div>
                                        <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                            <button
                                                onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                style={{ cursor: "pointer" }}
                                            >
                                                Añadir Funciones
                                                </button>
                                        </div>
                                    </div>
                                    {
                                        this.state.element.function ?
                                            <div className="form-group">
                                                <ul>
                                                    {Object.keys(this.state.element.function).map((f, index) => (
                                                        f !== "filter" ?
                                                            <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                            :
                                                            ""
                                                    ))}
                                                </ul>
                                            </div>
                                            :
                                            ""
                                    }
                                </TabPane>
                                <TabPane tabId="functions">
                                    {
                                        this.state.element.function ?
                                            <div>
                                                <div className="form-group">
                                                    <div className="form-control-parametros" style={{ height: "40px" }}>
                                                        <div style={{ position: "absolute", top: "60px" }}>Filtros: </div>
                                                        <div style={{ textAlign: "right", position: "relative", top: "-3" }}>
                                                            <button
                                                                onClick={(e) => {
                                                                    if (this.state.element.function.filter) {
                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(this.state.element.function.filter)[0]].col_id_ = { type: "value" };
                                                                    } else {
                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter = {}
                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter = {
                                                                            unique: {
                                                                                col_id_: { type: "value" }
                                                                            }
                                                                        }
                                                                    }
                                                                    this.setState({ data: arrData, onEdit: true });
                                                                }}
                                                                type="button"
                                                                className="btn btn-success btn-circle"
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.element.function.filter
                                                        ?
                                                        Object.keys(this.state.element.function).map((fn, indexZ) => (
                                                            fn === "filter" ?
                                                                Object.values(Object.values(this.state.element.function)[indexZ]).map((d) => (
                                                                    <div>
                                                                        {
                                                                            Object.values(Object.values(Object.values(this.state.element.function)[indexZ])[0]).length > 1 ?
                                                                                <div className="form-group">
                                                                                    <Select
                                                                                        name="form-field-name"
                                                                                        className="Select Select--single is-clearable is-searchable has-value"
                                                                                        value={Object.keys(Object.values(this.state.element.function)[indexZ])[0]}
                                                                                        options={options}
                                                                                        onChange={(e) => {
                                                                                            var fx = Object.values(this.state.element.function.filter)[0]
                                                                                            arrData.pages[this.state.page].elements[this.state.index].function = { filter: { [e.value]: [fx][0] } }
                                                                                            this.setState({ data: arrData });
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                ""
                                                                        }
                                                                        {
                                                                            Object.values(d).map((f, index) => (
                                                                                <div key={index} className={"card card-outline-primary mb-3"}>
                                                                                    <div className="card-block-parametros">
                                                                                        <div
                                                                                            style={{ position: "absolute", right: "1%", cursor: "pointer", color: "#d33115" }}
                                                                                            onClick={() => {
                                                                                                delete arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(Object.values(this.state.element.function)[indexZ])[0]][Object.keys(d)[index]];
                                                                                                if (Object.values(Object.values(Object.values(this.state.element.function)[indexZ])[0]).length === 1) {
                                                                                                    var fx = Object.values(Object.values(this.state.element.function)[indexZ])[0];
                                                                                                    arrData.pages[this.state.page].elements[this.state.index].function.filter = { unique: [fx][0] }
                                                                                                }
                                                                                                this.setState({ data: arrData });
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-times" aria-hidden="true"></i>
                                                                                        </div>
                                                                                        <blockquote className="card-blockquote" style={{ paddingRight: "10px", paddingLeft: "10px", paddingTop: "20px" }}>
                                                                                            <DetailFunction
                                                                                                data={this.state.data.pages}
                                                                                                col={Object.keys(d)[index]}
                                                                                                tipo={Object.keys(f)[0]}
                                                                                                value={Object.values(f)[0]}
                                                                                                element={this.state.element}
                                                                                                updateFilter={(col, type, value) => {
                                                                                                    if (col === Object.keys(d)[index]) {
                                                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter[Object.keys(Object.values(this.state.element.function)[indexZ])[0]][Object.keys(d)[index]] = { [type]: value };
                                                                                                        this.setState({ data: arrData });
                                                                                                        this.setTrigger(type, this.state.element.id);
                                                                                                    } else {
                                                                                                        delete arrData.pages[this.state.page].elements[this.state.index].function.filter[[Object.keys(Object.values(this.state.element.function)[indexZ])[0]]][Object.keys(d)[index]];
                                                                                                        arrData.pages[this.state.page].elements[this.state.index].function.filter[[Object.keys(Object.values(this.state.element.function)[indexZ])[0]]][col] = { [type]: value };
                                                                                                        this.setState({ data: arrData });
                                                                                                        this.setTrigger(type, this.state.element.id);
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </blockquote>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                ))
                                                                :
                                                                ""
                                                        ))
                                                        :
                                                        ""
                                                }
                                            </div>
                                            :
                                            ""
                                    }
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                );
                break;
            case 'BUTTON':
                var options = [
                    {
                        value: "NEXT",
                        label: "Avanzar página"
                    },
                    {
                        value: "PREV",
                        label: "Retroceder página"
                    },
                    {
                        value: "GOTO",
                        label: "Saltar a página:"
                    },
                    {
                        value: "SAVE",
                        label: "Guardar"
                    }
                ]
                var pages = []
                Object.keys(this.state.data.pages).map(p => {
                    pages.push({
                        value: p,
                        label: p
                    })
                })
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Texto:</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.text}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].text = e.target.value;
                                        this.state.data.pages[this.state.page].elements = arrayEdit;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group row">
                                <label className="col-md-4 form-control-label" style={{ color: "#20a8d8" }} >Color de fondo:</label>
                                <div className="col-md-3">
                                    <ColorPicker
                                        color={this.state.element.style.backgroundColor}
                                        callBack={(color) => {
                                            arrayEdit[this.state.index].style.backgroundColor = color.hex;
                                            this.state.data.pages[this.state.page].elements = arrayEdit;
                                            this.setState({ elements: arrayEdit, onEdit: true });
                                        }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-4 form-control-label" style={{ color: "#20a8d8" }} >Color del texto:</label>
                                <div className="col-md-3">
                                    <ColorPicker
                                        color={this.state.element.style.color}
                                        callBack={(color) => {
                                            arrayEdit[this.state.index].style.color = color.hex;
                                            this.state.data.pages[this.state.page].elements = arrayEdit;
                                            this.setState({ elements: arrayEdit, onEdit: true });
                                        }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Acción:</label>
                                <Select
                                    name="form-field-name"
                                    className="Select Select--single is-clearable is-searchable has-value"
                                    value={this.state.element.action ? Object.keys(this.state.element.action)[0] : this.state.element.action}
                                    options={options}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].action = {};
                                        arrayEdit[this.state.index].action[e.value] = true;
                                        this.state.data.pages[this.state.page].elements = arrayEdit;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }}
                                />
                            </div>
                            {
                                this.state.element.action ?
                                    this.state.element.action.GOTO ?
                                        <div className="form-group">
                                            <label htmlFor="name" style={{ color: "#20a8d8" }}>Página:</label>
                                            <Select
                                                name="form-field-name"
                                                value={this.state.element.action ? Object.values(this.state.element.action)[0] : this.state.element.action}
                                                options={pages}
                                                onChange={(e) => {
                                                    arrayEdit[this.state.index].action.GOTO = e.value;
                                                    this.state.data.pages[this.state.page].elements = arrayEdit;
                                                    this.setState({ elements: arrayEdit, onEdit: true });
                                                }}
                                            />
                                        </div>
                                        :
                                        ""
                                    :
                                    ""
                            }
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'INPUT':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Título (opcional):</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.label}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].label = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Valor por defecto (opcional):</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.value}
                                    placeholder={this.state.element.value}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].value = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                                {this.searchElement(this.state.element.value, this.state.element.id)}
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Mensaje de ayuda:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.placeholder}
                                    placeholder={this.state.element.placeholder}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].placeholder = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Tipo de dato:</label>
                                <select className="form-control-parametros" id="ccmonth" placeholder={this.state.element.type} onChange={(e) => {
                                    arrayEdit[this.state.index].type = e.target.value;
                                    this.setState({ elements: arrayEdit, onEdit: true })
                                }} >
                                    <option value={this.state.element.type} hidden>{this.state.element.type}</option>
                                    <option value="numeric">Númerico</option>
                                    <option value="text">Texto</option>
                                    <option value="email-address">Correo Electronico</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Solo lectura</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.readOnly} onChange={(e) => { arrayEdit[this.state.index].readOnly = !arrayEdit[this.state.index].readOnly; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Requerido</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.isRequired} onChange={(e) => { arrayEdit[this.state.index].isRequired = !arrayEdit[this.state.index].isRequired; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;

            case 'LABEL':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Texto:</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.text}
                                    placeholder={this.state.element.text}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].text = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Tamaño del texto:</label>
                                <select className="form-control-parametros" id="ccmonth" onChange={(e) => {
                                    arrayEdit[this.state.index].style.size = e.target.value;
                                    this.setState({ elements: arrayEdit, onEdit: true });
                                }} >
                                    <option value="" hidden >{this.state.element.style.size ? this.diccionario(this.state.element.style.size) : "seleccione"}</option>
                                    <option value="h2" >Grande</option>
                                    <option value="h4" >Mediana</option>
                                    <option value="h5" >Chica</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Estilo del texto:</label>
                                <select className="form-control-parametros" id="ccmonth" onChange={(e) => {
                                    arrayEdit[this.state.index].style.type = e.target.value;
                                    this.setState({ elements: arrayEdit, onEdit: true });
                                }} >
                                    <option value="" hidden >{this.state.element.style.type ? this.diccionario(this.state.element.style.type) : "seleccione"}</option>
                                    <option value="default" >Por defecto</option>
                                    <option value="italic" >Cursiva</option>
                                    <option value="bold" >Negrita</option>
                                </select>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-4 form-control-label" style={{ color: "#20a8d8" }} >Color del texto:</label>
                                <div className="col-md-3">
                                    <ColorPicker
                                        color={this.state.element.style.color}
                                        callBack={(color) => {
                                            arrayEdit[this.state.index].style.color = color.hex;
                                            this.setState({ elements: arrayEdit, onEdit: true });
                                        }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'CHECKBOX':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Texto:</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.text}
                                    placeholder="Campo Opcional"
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].text = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Marcado: </b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.value} onClick={(e) => {
                                            this.state.element.value === false ?
                                                arrayEdit[this.state.index].value = true
                                                :
                                                arrayEdit[this.state.index].value = false;
                                            this.setState({ elements: arrayEdit, onEdit: true })
                                        }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Recordar valor</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.remember} onChange={(e) => { arrayEdit[this.state.index].remember = !arrayEdit[this.state.index].remember; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
            case 'SECTION':
                return (
                    <div className="row" style={{ height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 122, overflow: "auto" }}>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre de campo:</label>
                                <input type="text" className="form-control-parametros" id="name" value={this.state.element.id}
                                    placeholder={this.state.element.id}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].id = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Texto:</label>
                                <input type="text" className="form-control-parametros" id="name"
                                    value={this.state.element.text}
                                    placeholder={this.state.element.text}
                                    onChange={(e) => {
                                        arrayEdit[this.state.index].text = e.target.value;
                                        this.setState({ elements: arrayEdit, onEdit: true });
                                    }} />
                            </div>
                            <div className="form-group row">
                                <label className="col-md-4 form-control-label" style={{ color: "#20a8d8" }} >Color de fondo:</label>
                                <div className="col-md-3">
                                    <ColorPicker
                                        color={this.state.element.style.backgroundColor}
                                        callBack={(color) => {
                                            arrayEdit[this.state.index].style.backgroundColor = color.hex;
                                            this.setState({ elements: arrayEdit, onEdit: true });
                                        }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-4 form-control-label" style={{ color: "#20a8d8" }} >Color del texto:</label>
                                <div className="col-md-3">
                                    <ColorPicker
                                        color={this.state.element.style.color}
                                        callBack={(color) => {
                                            arrayEdit[this.state.index].style.color = color.hex;
                                            this.setState({ elements: arrayEdit, onEdit: true });
                                        }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="clearfix mt-4">
                                    <small><b>Visible</b></small>
                                    <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                        <input type="checkbox" className="switch-input" checked={this.state.element.visible} onChange={(e) => { arrayEdit[this.state.index].visible = !arrayEdit[this.state.index].visible; this.setState({ elements: arrayEdit, onEdit: true }); }} />
                                        <span className="switch-label" data-on="On" data-off="Off"></span>
                                        <span className="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-control-parametros" style={{ height: "40px" }}>
                                <div>Funciones: </div>
                                <div style={{ textAlign: "right", position: "relative", top: "-17" }}>
                                    <button
                                        onClick={(e) => { this.setState({ showModalFunctions: true }) }}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Añadir Funciones
                                                </button>
                                </div>
                            </div>
                            {
                                this.state.element.function ?
                                    <div className="form-group">
                                        <ul>
                                            {Object.keys(this.state.element.function).map((f, index) => (
                                                f !== "filter" ?
                                                    <h6 key={index}>{f === "show" ? "Mostrar " : ""}<span className="badge badge-default"><i className="fa fa-times" onClick={() => this.deleteFunctions()} aria-hidden="true"></i></span></h6>
                                                    :
                                                    ""
                                            ))}
                                        </ul>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                );
                break;
        }
    }

    insertElement(element, index) {
        var arrNewElem = this.state.data.pages[this.state.page].elements;
        switch (element) {
            case 'calendar':
                var new_id = this.validadorID("CALENDAR", this.state.count);
                var button = {
                    element_id: "CALENDAR",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    action: {},
                    label: "",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, button);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'buttonGroup':
                var new_id = this.validadorID("BUTTONGROUP", this.state.count);
                var radioButton = {
                    element_id: "BUTTONGROUP",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    value: "",
                    childrens: [{
                        text: "Boton 1",
                        value: "boton_grp_1",
                        style: {
                            color: "#111111",
                            backgroundColor: "#FFFFFF"
                        },
                    },
                    {
                        text: "Boton 2",
                        value: "boton_grp_2",
                        style: {
                            color: "#111111",
                            backgroundColor: "#FFFFFF"
                        },
                    }],
                    function: {},
                    label: ""
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, radioButton);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'camera':
                var new_id = this.validadorID("CAMERA", this.state.count);
                var camera = {
                    element_id: "CAMERA",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    text: "CAMARA",
                    photo_name: "",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 })
                arrNewElem.splice(index, 0, camera);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'barcode':
                var new_id = this.validadorID("BARCODE", this.state.count);
                var barcode = {
                    element_id: "BARCODE",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    text: "CODIGO de BARRA",
                    barcode_name: "",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, barcode);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'radiobutton':
                var new_id = this.validadorID("RADIOBUTTON", this.state.count);
                var radioButton = {
                    element_id: "RADIOBUTTON",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    value: "",
                    childrens: [{
                        text: "Alternativa 1",
                        value: "Alternativa_1"
                    },
                    {
                        text: "Alternativa 2",
                        value: "Alternativa_1"
                    }],
                    function: {},
                    label: ""
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, radioButton);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'image':
                var new_id = this.validadorID("IMAGE", this.state.count);
                var image = {
                    element_id: "IMAGE",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    uri: "/img/image.svg",
                    value: "assets/image.svg",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, image);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'button':
                var new_id = this.validadorID("BUTTON", this.state.count);
                var button = {
                    element_id: "BUTTON",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    action: {},
                    text: "BOTON",
                    style: {
                        color: "#111111",
                        backgroundColor: "#FFFFFF"
                    },
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, button);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'input':
                var new_id = this.validadorID("INPUT", this.state.count);
                var input = {
                    element_id: "INPUT",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    placeholder: "ENTRADA DE TEXTO",
                    function: {},
                    value: "",
                    label: ""
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, input);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'title':
                var new_id = this.validadorID("TITLE", this.state.count);
                var title = {
                    element_id: "TITLE",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    text: "TITULO",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, title);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'label':
                var new_id = this.validadorID("LABEL", this.state.count);
                var label = {
                    element_id: "LABEL",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    text: "ETIQUETA",
                    function: {},
                    style: {
                        color: "#111111",
                        size: "h4",
                        type: "default"
                    }
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, label);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'checkbox':
                var new_id = this.validadorID("CHECKBOX", this.state.count);
                var checkbox = {
                    element_id: "CHECKBOX",
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    text: "Texto CHECK",
                    value: false,
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, checkbox);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'section':
                var new_id = this.validadorID("SECTION", this.state.count);
                var section = {
                    element_id: "SECTION",
                    id: new_id,
                    visible: true,
                    style: {
                        color: "#111111",
                        backgroundColor: "#FFFFFF"
                    },
                    isRequired: false,
                    text: "SEPARADOR",
                    function: {}
                };
                this.setState({ draggable: false, count: this.state.count + 1 });
                arrNewElem.splice(index, 0, section);
                this.setState({ newOrders: arrNewElem })
                break;
            case 'stores':
                var count = 0;
                arrNewElem.map((e) => {
                    if (e.element_id !== "STORE") {
                        count = count + 1;
                    }
                });
                if (count === arrNewElem.length) {
                    var new_id = "codloc";
                    var store = {
                        element_id: "STORE",
                        id: new_id,
                        visible: true,
                        isRequired: false,
                        function: {},
                        label: ""
                    };
                    this.setState({ draggable: false, count: this.state.count + 1 });
                    arrNewElem.splice(index, 0, store);
                    this.setState({ newOrders: arrNewElem })
                }
                break;
            case 'dropdown':
                var new_id = this.validadorID("DROPDOWNLIST", this.state.count);
                var dropdownlist = {
                    element_id: "DROPDOWNLIST",
                    function: {},
                    id: new_id,
                    visible: true,
                    isRequired: false,
                    table: {
                        dataset: "id dataset",
                        dataset_name: "Seleccione dataset",
                        col_id: "columna id",
                        col_name: "columna valor"
                    },
                    label: ""
                };
                this.setState({ draggable: false, count: this.state.count + 1, onEdit: false });
                arrNewElem.splice(index, 0, dropdownlist);
                this.setState({ newOrders: arrNewElem });
                break;
        }
    }

    updateElements(oldIndex, newIndex) {
        var oldArr = Object.assign([], this.state.data.pages[this.state.page].elements);
        var newArr = Object.assign({}, this.state.data);
        newArr.pages[this.state.page].elements.splice(oldIndex, 1);
        newArr.pages[this.state.page].elements.splice(newIndex, 0, oldArr[oldIndex]);
        this.setState({ data: newArr })
    }

    moveElement(order) {
        var arr = this.state.data.pages[this.state.page].elements;
        var arrNew = [];
        arr.map((e, i) => {
            if (order[i]) {
                arrNew.push(this.state.data.pages[this.state.page].elements[order[i].id]);
            }
        })
        this.setState({ newOrders: arrNew })
    }

    validadorID(name, index) {
        var count = 0;
        var id = (name + "_" + (index)).toString();
        var arrayEdit = this.state.data.pages[this.state.page].elements;
        arrayEdit.map((e) => {
            if (e.id != id) {
                count = count + 1;
            }
        });
        if (count === arrayEdit.length) {
            return id;
        } else {
            return this.validadorID(name, index + 1);
        }
    }

    setTrigger(trigger, activator) {
        var arrayEdit = this.state.data;
        Object.values(this.state.data.pages).map((f, indexPage) => {
            Object.values(f.elements).map((m, indexElements) => {
                if (m.id === trigger) {
                    arrayEdit.pages[indexPage].elements[indexElements].triggers ?
                        ""
                        :
                        arrayEdit.pages[indexPage].elements[indexElements].triggers = {};
                    arrayEdit.pages[indexPage].elements[indexElements].triggers[activator] = true;
                }
                if (m.id === activator) {
                    arrayEdit.pages[indexPage].elements[indexElements].activators ?
                        ""
                        :
                        arrayEdit.pages[indexPage].elements[indexElements].activators = {};
                    arrayEdit.pages[indexPage].elements[indexElements].activators[trigger] = true;
                }
            })
        });
        this.setState({ data: arrayEdit })
    }

    setFunctions(obj, triggers) {
        this.setState({ showModalFunctions: false })
        var arrayEdit = this.state.data;
        if (Object.keys(obj)[0] === "show") {
            arrayEdit.pages[this.state.page].elements[this.state.index].visible = false;
        }
        if (arrayEdit.pages[this.state.page].elements[this.state.index].function) {
            arrayEdit.pages[this.state.page].elements[this.state.index].function[Object.keys(obj)[0]] = Object.values(obj)[0];
            triggers.map((t) => {
                arrayEdit.pages[this.state.page].elements[this.state.index].activators ?
                    ""
                    :
                    arrayEdit.pages[this.state.page].elements[this.state.index].activators = {};
                arrayEdit.pages[this.state.page].elements[this.state.index].activators[t] = true;

            })
        } else {
            arrayEdit.pages[this.state.page].elements[this.state.index].function = {};
            arrayEdit.pages[this.state.page].elements[this.state.index].function[Object.keys(obj)[0]] = Object.values(obj)[0];
            triggers.map((t) => {
                arrayEdit.pages[this.state.page].elements[this.state.index].activators ?
                    ""
                    :
                    arrayEdit.pages[this.state.page].elements[this.state.index].activators = {};
                arrayEdit.pages[this.state.page].elements[this.state.index].activators[t] = true;

            })
        }
        arrayEdit.pages[this.state.page].elements.map((e, index) => {
            triggers.map(t => {
                var obj = {}
                if (e.id === t[0]) {
                    obj[this.state.element.id] = true;
                    arrayEdit.pages[this.state.page].elements[index].triggers ?
                        "" : arrayEdit.pages[this.state.page].elements[index].triggers = {};
                    arrayEdit.pages[this.state.page].elements[index].triggers[this.state.element.id] = true;
                }
            })
        })
        this.setState({ data: arrayEdit });
    }

    deleteFunctions() {
        var arrayEdit = this.state.data.pages[this.state.page].elements;
        var id = this.state.element.id;
        Object.keys(arrayEdit[this.state.index].activators).map((a) => {
            arrayEdit.map((e) => {
                if (e.id == a) {
                    Object.keys(e.triggers).map((t, index) => {
                        e.triggers[t] = false;
                    })
                }
            });
            if (Object.keys(arrayEdit[this.state.index].function)[0] === "show") {
                arrayEdit[this.state.index].visible = true;
            }
            arrayEdit[this.state.index].activators = {};
            arrayEdit[this.state.index].function = {};
            arrayEdit[this.state.index].visible = true;
            this.setState({ elements: arrayEdit });
        })
    }

    removeOutPut(name) {
        var arrayEdit = this.state.data;
        delete arrayEdit.output[name];
        this.setState({ data: arrayEdit });
    }

    setOutPut(arr) {
        var output = Object.values(arr)[0];
        var arrayEdit = this.state.data;
        if (arrayEdit.output) {
            arrayEdit.output[Object.keys(arr)] = output;
            this.setState({ data: arrayEdit, showModalOutPut: false });
        } else {
            arrayEdit.output = {};
            arrayEdit.output[Object.keys(arr)] = output;
            this.setState({ data: arrayEdit, showModalOutPut: false });
        }
    }

    deletePage() {
        var arrData = this.state.data;
        if (arrData.pages.length > 1) {
            arrData.pages.splice(this.state.page, 1);
            this.setState({ data: arrData, page: 0 });
        } else {
            this.refs.container.warning(
                "No es posible eliminar la última página del formulario",
                "Elimando página", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                });
        }
    }

    searchElement(text, id) {
        var regExp = /{{([^}]+)}}/g;
        var matches = regExp.exec(text);
        var match = false;
        if (matches) {
            Object.values(this.state.data.pages).map((f) => {
                Object.values(f.elements).map((m, index) => {
                    if (m.id === matches[1]) {
                        match = true;
                    }
                })
            });
        }
        if (match) {
            return (
                <div className="small text-muted">
                    Desea vincular al valor del elemento : {matches[1]}
                    <span className="badge badge-success" style={{ cursor: "pointer" }} onClick={() => this.setTrigger(matches[1], id)} >Si</span>
                    {" "}
                    <span className="badge badge-danger">No</span></div>
            )
        }
    }

    DateToFormattedString(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    renderForm() {
        var data = this.state.data;
        var arrElem = [];
        var arrData = [];
        var arrPages = [];
        if (this.state.data.pages) {
            arrElem = Object.values(this.state.data.pages)[this.state.page].elements;
            arrData = this.state.data;
            arrPages = Object.keys(this.state.data.pages);
        }
        switch (this.state.visibility) {
            case true:
                return (
                    <div className="contenedor-preview" style={{overflow : "auto", position : "absolute !important"}}>
                        <div style={{
                            borderColor: "#263238", margin: "auto", borderStyle: "solid", borderRadius: "30px",
                            borderBottomWidth: "30px", borderTopWidth: "30px", borderLeftWidth: "15px",
                            borderRightWidth: "15px", maxWidth: "550px", height: "875px",
                        }} >
                            <button className="btn btn-success"
                                onClick={() => this.state.page > 0 ? this.setState({ page: this.state.page - 1 }) : ""}
                                style={this.state.page > 0 ? { position: "absolute", margin: "auto", left: "0", cursor: "pointer" } : { display: "none" }}
                            ><i className="fa fa-arrow-left" aria-hidden="true"></i> Prev</button>
                            {"    "}
                            <button className="btn btn-success"
                                onClick={() => Object.keys(this.state.data.pages).length > this.state.page ? this.setState({ page: this.state.page + 1 }) : ""}
                                style={(this.state.data.pages.length - 1) > this.state.page ? { position: "absolute", margin: "auto", right: "0", cursor: "pointer" } : { display: "none" }}
                            >Next <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                            <div className="card text-center" onClick={() => this.setState({ activeTab: "2" })} style={{ marginBottom: "0", width: "100%", paddingBottom: "5px", borderColor: "white" }}>
                                <h3>{this.state.data.pages ? this.state.data.pages[this.state.page].title : ""}</h3>
                            </div>
                            <div style={{ maxHeight: "1200px", overflowY: "auto", height: "808px", padding: "20px", backgroundColor: "#FFF" }}>
                                {
                                    this.state.data.pages ?
                                        Object.values(this.state.data.pages[this.state.page].elements).map((e, key) => (
                                            <div className="card text-center"
                                                style={{ marginBottom: "0", paddingBottom: "5px", borderColor: "white" }}
                                                id={key} key={key}
                                            >
                                                <EditComponents element={e} index={key} />
                                            </div>
                                        ))
                                        :
                                        ""
                                }
                                <div className="text-center">
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                );
            case false:
                return (
                    <div>
                        <div style={{ margin: "auto", maxWidth: "550px", marginTop: "18px" }}>
                            <div style={{ padding: "10px", backgroundColor: "#FFF", textAlign: "center", borderRadius: "10px" }}>
                                <h3 id="page_title" style={{ display: "" }}>{this.state.data.pages ? this.state.data.pages[this.state.page].title : "Título de página"}</h3>
                                <div className="clearfix mt-4" id="page_title_edit" style={{ display: "none" }}>
                                    <div className="form-group">
                                        <label htmlFor="name">Título de Página</label>
                                        <input type="text" className="form-control" id="name" value={this.state.data.pages ? this.state.data.pages[this.state.page].title : this.state.namePage} onChange={(e) => { data.pages[this.state.page].title = e.target.value; this.setState({ data: data }) }}
                                            placeholder="Título de página" />
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-circle"
                                    style={{ position: "absolute", right: "10%", top: "50", cursor: "pointer" }}
                                    onClick={() => {
                                        var title = document.getElementById("page_title");
                                        var edit = document.getElementById("page_title_edit");
                                        title.style.display === "none" ? title.style.display = "" : title.style.display = "none";
                                        edit.style.display === "" ? edit.style.display = "none" : edit.style.display = "";
                                    }}
                                >
                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-circle"
                                    style={{ position: "absolute", right: "2%", top: "3", cursor: "pointer" }}
                                    onClick={() => {
                                        var modal = document.getElementById("myModal");
                                        modal.style.display = "";
                                    }}
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </button>
                                <div id="myModal" className="Mymodal" style={{ display: "none" }}>
                                    <div className="Mymodal-content">
                                        <div>
                                            <h2><i className="fa fa-trash-o" aria-hidden="true"></i> Está seguro de eliminar esta página?</h2>
                                        </div>
                                        <br />
                                        <div className="text-right">
                                            <button
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    var modal = document.getElementById("myModal");
                                                    modal.style.display = "none";
                                                }}
                                                type="button"
                                                className="btn btn-outline-danger"
                                            >
                                                No
                                            </button>
                                            {"  "}
                                            <button
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    this.deletePage();
                                                    var modal = document.getElementById("myModal");
                                                    modal.style.display = "none";
                                                }}
                                                type="button"
                                                className="btn btn-outline-success"
                                            >
                                                Si
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Sortable id="group-right"
                                style={{ padding: "20px" }}
                                onChange={(order, sortable, evt) => {
                                    console.log("onChange")
                                }}
                                options={{
                                    animation: 150,
                                    onUpdate: (evt) => {
                                        console.log("onUpdate");
                                        this.updateElements(evt.oldIndex, evt.newIndex)
                                    },
                                    onSort: (evt) => {
                                        console.log("onSort");
                                        this.moveElement(evt.from.children)
                                    },
                                    onEnd: (evt) => {
                                        console.log("onEnd");
                                        if (evt.newIndex !== evt.oldIndex) {
                                            this.setState({ elements: {} })
                                            this.setState({ elements: this.state.newOrders })
                                        }
                                    },
                                    onAdd: (evt) => {
                                        console.log("onAdd");
                                        this.forceUpdate();
                                        this.insertElement(evt.item.id, evt.newIndex);
                                        this.setState({ elements: {} })
                                        this.setState({ elements: this.state.newOrders })
                                    },
                                    onRemove: (evt) => {
                                        console.log("onRemove")
                                    },
                                    group: {
                                        name: 'element',
                                        pull: false,
                                        put: 'element1'
                                    }
                                }}
                            >
                                {
                                    this.state.data.pages ?
                                        Object.values(this.state.data.pages[this.state.page].elements).map((e, key) => (
                                            <div className={key === this.state.index ? "card text-center zoom-active" : "card text-center zoom"}
                                                style={{ borderColor: "#20a8d8", padding: "10px", minHeight: "70px" }}
                                                id={key}
                                                key={key}
                                            >
                                                <div id="social-share"
                                                    className="open"
                                                    style={key === this.state.index ? { position: "absolute", zIndex: "4", right: "30px", cursor: "pointer", top: "0" } : { display: "none" }}
                                                >
                                                    <div className="a2a_kit a2a_kit_size_32 addtoany_list">
                                                        <button type="button" className="btn btn-danger btn-circle"
                                                            onClick={() => { this.setState({ onEdit: false }); arrElem.splice(key, 1); this.setState({ elements: arrElem }) }}
                                                        >
                                                            <i className="fa fa-times" aria-hidden="true"></i>
                                                        </button>
                                                        <button type="button" className="btn btn-primary btn-circle"
                                                            onClick={() => { var elem = Object.assign({}, e); elem.id = this.validadorID(e.element_id, key); arrElem.splice(key + 1, 0, elem); this.setState({ elements: arrElem }) }}
                                                        >
                                                            <i className="fa fa-clone" aria-hidden="true"></i>
                                                        </button>
                                                        <button type="button" className="btn btn-success btn-circle"
                                                            onClick={() => this.setState({ element: e })}
                                                        >
                                                            <i className="fa fa-pencil" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div id="selector" style={{ position: "absolute", height: "100%", width: "95%", top: "5px" }} onClick={() => {
                                                    this.setState({ element: {}, index: key, onEdit: true, activeTab: "1" });
                                                }}>
                                                    <EditComponents element={e} index={key} />
                                                </div>
                                            </div>
                                        ))
                                        :
                                        ""
                                }
                            </Sortable>
                        </div>
                    </div>
                );
        }
    }

    render() {
        window.setInterval(this.autoSave(), 20000);
        var arrElem = [];
        var arrData = [];
        var arrPages = [];
        if (this.state.data.pages) {
            arrElem = Object.values(this.state.data.pages)[this.state.page].elements;
            arrData = this.state.data;
            arrPages = Object.keys(this.state.data.pages);
        }
        var data = this.state.data;
        var aux;
        var hora = new Date(this.state.data.modified_at);
        var horaRespaldo = this.DateToFormattedString(hora);
        return (
            <div className="animated fadeIn" style={{ overflow: "hidden", left: "0", right: "0", margin: "auto", position: "absolute", top: "55px", bottom: "49px" }}>
                <ToastContainer ref="container"
                    style={{ top: "60px" }}
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right"
                />
                <div className="row text-center" style={{ borderBottom: "5px solid #CCCCCC", height: "40px", background: "#FFF" }} >
                    <div className="col-md-3">
                        <div style={{ color: "#4dbd74", marginTop: "7px" }}>último respaldo: {horaRespaldo}</div>
                    </div>
                    <div className="col-md-6">
                        <ul className="nav justify-content-center">
                            <li className="nav-item" onClick={() => this.setState({ tab: "edit" })}>
                                <a className="nav-link active" style={{ cursor: "pointer" }}>Editor</a>
                            </li>
                            <li className="nav-item" onClick={() => this.setState({ tab: "settings" })}>
                                <a className="nav-link" style={{ cursor: "pointer" }}>Opciones</a>
                            </li>
                            <li className="nav-item" onClick={() => this.setState({ tab: "publish" })}>
                                <a className="nav-link" style={{ cursor: "pointer" }}>Publicar</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <div className="text-right" style={{ marginTop: "7px", position: "absolute", right: "40px" }}>
                            <div className="row">
                                <small style={{ marginRight: "10px" }}><b>Vista previa</b></small>
                                <label className="switch switch-default switch-pill switch-success-outline-alt">
                                    <input type="checkbox" className="switch-input" defaultChecked checked={this.state.visibility} onClick={() => { this.setState({ visibility: !this.state.visibility, tab: "edit" }) }} />
                                    <span className="switch-label"></span>
                                    <span className="switch-handle"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <TabContent activeTab={this.state.tab} style={{ marginBottom: "-30px" }}>
                    <TabPane tabId="edit" style={this.state.visibility ? { background: "#2185d0" } : {}}>
                        <div className="from-group row" >
                            <div className="col-md-3" style={this.state.visibility ? { display: "none" } : { backgroundColor: "#263238", position: "relative", top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137, overflow: "auto" }}>
                                <a className="nav-link nav-dropdown-toggle" style={{ color: "#FFF" }}><i className="fa fa-cart-plus"></i> Elementos</a>
                                <div className="col-md-12" style={{ color: "#ffffff" }}>
                                    <Sortable ref="group-left" className="form-group row" options={{
                                        group: {
                                            name: 'element1',
                                            pull: "false",
                                            put: false
                                        }
                                    }}
                                        onChange={(e) =>
                                            console.log(e)
                                        }>
                                        {
                                            this.state.elementos.map((e) => (
                                                e
                                            ))
                                        }
                                    </Sortable>
                                </div>
                                <a className="nav-link nav-dropdown-toggle" style={{ color: "#FFF" }} ><i className="fa fa-file-o"></i> Páginas</a>
                                <div className="col-md-12" style={{ color: "#ffffff" }}>
                                    <div className="form-group row">
                                        <div className="elemento text-center col-md-12 col-lg-6 col-sm-12 image">
                                            <NavLink className="nav-link"
                                                activeClassName="active"
                                                onClick={() => { arrData.pages[arrData.pages.length] = { elements: [], title: "" }; this.setState({ data: arrData }) }}
                                            >
                                                <img src="/icons/add_page.svg" width="25%" style={{ cursor: "pointer" }} />
                                                <br />
                                                Añadir página
                                            </NavLink>
                                        </div>
                                        {
                                            arrPages.map((p, index) => (
                                                <div key={index} className="elemento text-center col-md-12 col-lg-6 col-sm-12 image" onClick={() => this.setState({ page: p })}>
                                                    <NavLink className="nav-link"
                                                        activeClassName="active"
                                                    >
                                                        <img src={this.state.page === p ? "/icons/selected_page.svg" : "/icons/page.svg"} width="25%" style={{ cursor: "pointer" }} />
                                                        <br />
                                                        Página {(p)}
                                                    </NavLink>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div >
                            <div className="col-md-6"
                                style={this.state.visibility ?
                                    { position: "inherit", margin: "auto", left: "0", right: "0", } :
                                    {
                                        position: "relative", top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137, overflow: "auto", backgroundImage: "linear-gradient(rgb(199, 241, 255), rgb(94, 146, 199))"
                                    }}
                            >
                                <br />
                                {this.renderForm()}
                                <Modal isOpen={this.state.showModalFunctions} toggle={() => { this.setState({ showModalFunctions: false }) }} className="modal-dialog modal-lg">
                                    <ModalHeader toggle={() => { this.setState({ showModalFunctions: false }) }}>
                                    </ModalHeader>
                                    <ModalBody>
                                        <Functions elements={this.state.data.pages ? this.state.data.pages : []} pages={this.state.data.pages} element={this.state.element} callBack={this.setFunctions} />
                                    </ModalBody>
                                </Modal>
                            </div>
                            <div className="col-md-3" style={this.state.visibility ? { display: "none" } : { backgroundColor: "#263238", position: "relative", color: "#FFFFFF", top: "-15px", paddingTop: "15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137, overflow: "auto" }}>
                                {
                                    this.state.onEdit ?
                                        <div>
                                            {
                                                this.setParams()
                                            }
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="settings" style={{ backgroundImage: "linear-gradient(#bcf1ce, #476551)" }}>
                        <div className="form-group row">
                            <div className="col-md-3" style={{ backgroundColor: "#263238", color: "#FFF", position: "relative", top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137 }}>
                                <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px", padding: "10px",
                                        marginTop: "20px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabSettings: "global" })}
                                >
                                    <a style={{ color: "#FFF" }}>Configuración global</a>
                                </div>
                                <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px",
                                        padding: "10px", marginTop: "2px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabSettings: "output" })}
                                >
                                    <a style={{ color: "#FFF" }}>Configurar Output</a>
                                </div>
                                {/*                                 <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px",
                                        padding: "10px", marginTop: "2px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabSettings: "connect" })}
                                >
                                    <a style={{ color: "#FFF" }} >Conectar con fuente externa</a>
                                </div> */}
                                {/*                                 <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px",
                                        padding: "10px", marginTop: "2px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabSettings: "updateDatasets" })}
                                >
                                    <a style={{ color: "#FFF" }} >Actualizar set de datos</a>
                                </div> */}
                            </div>
                            <div className="col-md-9" style={{ top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137 }}>
                                <br />
                                <TabContent activeTab={this.state.tabSettings}>
                                    <TabPane tabId="global" style={{ boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                                        <div className="clearfix mt-4">
                                            <div className="form-group">
                                                <label htmlFor="name">Nombre del Formulario</label>
                                                <input type="text" className="form-control" id="name" value={this.state.data.name} onChange={(e) => { data.name = e.target.value; this.setState({ data: data }) }}
                                                    placeholder="Nombre del formulario" />
                                            </div>
                                        </div>
                                        <h6>Opciones Generales</h6>
                                        <hr />
                                        <div className="aside-options">
                                            <div className="clearfix mt-4">
                                                <small><b>Formulario habilitado</b></small>
                                                <label className="switch switch-text switch-pill switch-success switch-sm float-right">
                                                    <input type="checkbox" className="switch-input" checked={this.state.data.published} onClick={() => { var data = this.state.data; data.published = !this.state.data.published; this.setState({ data: data }) }} />
                                                    <span className="switch-label" data-on="On" data-off="Off"></span>
                                                    <span className="switch-handle"></span>
                                                </label>
                                            </div>
                                            <hr />
                                            <div className="clearfix mt-4">
                                                <small><b>Usar GPS</b></small>
                                                <Select
                                                    name="form-field-name"
                                                    className="Select Select--single is-clearable is-searchable has-value"
                                                    value={this.state.data.gps}
                                                    options={gps_options}
                                                    onChange={(e) => {
                                                        var arrData = this.state.data; arrData.gps = e.value;
                                                        this.setState({ data: arrData })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <hr />
                                    </TabPane>
                                    <TabPane tabId="output" style={{ boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                                        <h3>Formato para datos de salida</h3>
                                        <p>Recuerde que el orden en el que seleccione los elementos, será el orden que tendrá el archivo de salida de los datos.</p>
                                        <br />
                                        <legend>Formatos:</legend>
                                        <ul className="list-group">
                                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                                <a onClick={(e) => { this.setState({ showModalOutPut: true }) }} >Crear Nuevo</a>
                                            </li>
                                            {
                                                this.state.data.output ?
                                                    Object.values(this.state.data.output).map((f, index) => (
                                                        <OutPut items={f} index={index} name={Object.keys(this.state.data.output)[index]} callBack={this.removeOutPut} />
                                                    ))
                                                    :
                                                    ""
                                            }
                                        </ul>
                                        <Modal isOpen={this.state.showModalOutPut} toggle={() => { this.setState({ showModalOutPut: false }) }} className="modal-dialog modal-lg">
                                            <ModalHeader toggle={() => { this.setState({ showModalOutPut: false }) }}>
                                            </ModalHeader>
                                            <ModalBody>
                                                <AddOutPut elements={this.state.data.pages} callBack={this.setOutPut} />
                                            </ModalBody>
                                        </Modal>
                                    </TabPane>
                                    <TabPane tabId="connect" style={{ boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.19)", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 170, overflow: "auto" }}>
                                        <h3>Configurar conexión con fuentes externas</h3>
                                        <p>Debe completar los datos a continuación para realizar el envió automático de los datos.</p>
                                        <br />
                                        <div className="card card-outline-primary mb-3" style={{ padding: "10px", borderRadius: "20px" }}>
                                            <div className="card-block">
                                                <blockquote className="card-blockquote">
                                                    <legend>Amazon S3:</legend>
                                                    <hr />
                                                    <div className="form-group">
                                                        <label>Credenciales :</label>
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Access_Key:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.access_key} />
                                                        </div>
                                                        <br />
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Secret_Key:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.secret_key} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Directorio raíz :</label>
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Bucket:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.bucket} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Directorio de archivos :</label>
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Path:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.path} />
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="card card-outline-primary mb-3" style={{ padding: "10px", borderRadius: "20px" }}>
                                            <div className="card-block">
                                                <blockquote className="card-blockquote">
                                                    <legend>Servidor FTP:</legend>
                                                    <hr />
                                                    <div className="form-group">
                                                        <label>Credenciales :</label>
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Dirección FTP:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.FTP} />
                                                        </div>
                                                        <br />
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Usuario:</span>
                                                            <input type="text" className="form-control" id="company" value={this.state.FTP_user} />
                                                        </div>
                                                        <br />
                                                        <div className="input-group">
                                                            <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Contraseña:</span>
                                                            <input type="password" className="form-control" id="company" value={this.state.FTP_pass} />
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="updateDatasets" style={{ boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.19)", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 170, overflow: "auto" }}>
                                        <h3>Configurar sobrescritura de datos</h3>
                                        <p>Debe seleccionar el elemento que contenga el set de datos que desee reemplazar, junto con el elemento de donde se obtendrá el valor o ingresar un valor predefinido</p>
                                        <br />
                                        <div className="card card-outline-primary mb-3" style={{ padding: "10px", borderRadius: "20px" }}>
                                            <div className="card-block">
                                                <blockquote className="card-blockquote">
                                                    {/*                                                     {this.state.data.pages ? <OverWriteDatasets data={this.state.data.pages} />
                                                        :
                                                        ""
                                                    } */}
                                                </blockquote>
                                            </div>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="publish" style={{ backgroundImage: "linear-gradient(#94dff9, #435961)" }}>
                        <div className="form-group row">
                            <div className="col-md-3" style={{ backgroundColor: "#263238", color: "#FFF", position: "relative", top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137 }}>
                                <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px",
                                        padding: "10px", marginTop: "2px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabPublish: "publish" })}
                                >
                                    <a style={{ color: "#FFF" }} >Publicar formulario</a>
                                </div>
                                <div
                                    className="elemento text-center"
                                    style={{
                                        borderWidth: "1px", borderColor: "#20a8d8",
                                        borderStyle: "solid", borderRadius: "10px",
                                        padding: "10px", marginTop: "2px", cursor: "pointer"
                                    }}
                                    onClick={() => this.setState({ tabPublish: "icons" })}
                                >
                                    <a style={{ color: "#FFF" }} >Seleccionar Icono</a>
                                </div>
                            </div>
                            <div className="col-md-9" style={{ top: "-15px", height: window.screen.availHeight - (window.outerHeight - window.innerHeight) - 137 }}>
                                <br />
                                <TabContent activeTab={this.state.tabPublish} style={{ backgroundColor: "transparent", border: "transparent" }}>
                                    <TabPane tabId="publish" style={{ backgroundColor: "#FFF", border: "1px solid #cfd8dc" }}>
                                        <Validator
                                            elements={this.state.data.pages ? this.state.data.pages[this.state.page].elements : []}
                                            publish={() => { this.setBackUp(); this.setState({ showModal: false }); }}
                                            style={{ boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}
                                        />
                                    </TabPane>
                                    <TabPane tabId="icons">
                                        <ListIcons setIcon={(i) => { arrData.icon = i; this.setState({ data: arrData }); }} formId={this.props.match.params.formId} />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/forms/editForm.js